export default __webpack_public_path__ + "static/media/Noman_Ali.7f1f23a4.png";